import * as React from 'react';
export const flagSvg = React.forwardRef(function flagSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1 1.5A1.5 1.5 0 0 1 2.5 0h4a2 2 0 0 1 2 2v1h5.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.044.252L13.796 8l1.16 3.248A.75.75 0 0 1 15 11.5v.75a.75.75 0 0 1-.75.75h-5.5A1.75 1.75 0 0 1 7 11.25V10H2.5v5.25a.75.75 0 0 1-1.5 0V1.5Zm1.5 0h4A.5.5 0 0 1 7 2v6.5H2.5v-7Zm6 3v6.75c0 .138.112.25.25.25h4.704l-1.16-3.248a.75.75 0 0 1 0-.504l1.16-3.248H8.5Z',
    }),
  );
});
flagSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var flag = {
  category: 'icon',
  colorable: true,
  name: 'flag',
  svg: flagSvg,
};
